import { defineComponent as p, computed as e, openBlock as a, createElementBlock as s, normalizeClass as n, createElementVNode as v, Fragment as g, renderList as f, renderSlot as w } from "vue";
import "@ds/components/Document";
import { tw as t } from "../../utils/tailwind.js";
const _ = /* @__PURE__ */ p({
  __name: "DocumentList",
  props: {
    documents: {},
    variant: { default: "grid" }
  },
  setup(l) {
    const r = l, i = e(() => [
      t`gap-16`,
      r.variant === "grid" && t`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2`,
      r.variant === "inline" && t`flex`
    ]), m = e(() => [
      // By spec, they have a fixed width only in the inline variant
      r.variant === "inline" && t`w-full min-w-240 max-w-448`
    ]), c = e(() => [
      // By spec, they have a fixed width only in the inline variant
      r.variant === "inline" && t`-mx-24 -mb-24 -mt-16 snap-x snap-mandatory scroll-pl-24 overflow-x-auto overscroll-x-contain scroll-smooth p-24 transition-transform duration-700 scrollbar-none`,
      r.variant === "grid" && t`mt-8`
    ]);
    return (d, x) => (a(), s("div", {
      class: n(c.value)
    }, [
      v("ul", {
        class: n(i.value)
      }, [
        (a(!0), s(g, null, f(l.documents, (u, o) => (a(), s("li", {
          key: o,
          class: n(m.value)
        }, [
          w(d.$slots, "item", {
            document: u,
            index: o
          })
        ], 2))), 128))
      ], 2)
    ], 2));
  }
});
export {
  _ as default
};
